import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import {
  ApiCaptchaImage
} from 'idt-ecommerce-api/_api/api-secure/api-secure.models';
import { ApiRequestService } from 'idt-ecommerce-api/_api/api-util/api-request.service';


export interface ApiSecureServiceInterface {
  getCaptchaImage(storeId: string, languageId: string): Observable<ApiCaptchaImage>;
}

@Injectable()
export class ApiSecureService implements ApiSecureServiceInterface {

  constructor(
    private readonly http: HttpClient,
    private readonly requestService: ApiRequestService
  ) {}

  public getCaptchaImage(storeId: string, languageId: string): Observable<ApiCaptchaImage> {
    const slug = `secure/store/${storeId}/captcha`;

    return this.requestService.requestUrl(slug, languageId, undefined, true).pipe(
      switchMap((url: string) => this.http.get<ApiCaptchaImage>(url))
    );
  }

}
